import { DeviceV2, RawDeviceV2 } from "@/entities";

export const mockRawDevicesServicePoint = (): RawDeviceV2[] => [
  {
    id: "c0528b78-4072-3a19-a599-440deb0e3f8a",
    code: "001344007070",
    name: "DEVICE TEST 02",
    type: "Recicladora",
    manufacturer: "CIMA",
    model: "SDM 504",
    countryCode: "PE",
    active: true,
    currencies: ["PEN", "USD"],
    manufacturerNoteCapacity: 200,
    realNoteCapacity: 200,
    prosegurNoteCapacity: 200,
    manufacturerCoinCapacity: 200,
    realCoinCapacity: 200,
    prosegurCoinCapacity: 200,
    deviceAlerts: [],
    clientMode: "Monocliente",
  },
];
